module.exports = __webpack_public_path__ + "img/1601transition.443ee5e3.svg";